import { render, staticRenderFns } from "./PortalList.vue?vue&type=template&id=5a14f774&scoped=true"
import script from "./PortalList.vue?vue&type=script&lang=js"
export * from "./PortalList.vue?vue&type=script&lang=js"
import style0 from "./PortalList.vue?vue&type=style&index=0&id=5a14f774&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a14f774",
  null
  
)

export default component.exports